import React from 'react';
import hooks from "./ChangePhoneHook";
import ModalComp from '../../../components/ModalComp/ModalComp';
import PhoneInputComponent from "../../../components/TextInput/PhoneInput";
import NumberFormatInput from "../../../components/TextInput/LoginInputs/NumberFormatInput";
import MainButton from "../../../components/ButtonsCont/MainButton";
import ClipLoader from "react-spinners/ClipLoader";
import validation from "../../../utils/validation";
import styles from "../ChangeEmail/changeEmail.module.scss";
// "./changePhone.module.scss";

function ChangeEmail(props) {
    const { showCode, set_input_value, change_phone, edit_phone_saga, keyPress, check_phone_saga } = hooks(props);
    const body = (
        <div>
            {!showCode ? <div>
                <div className="d-flex justify-content-center m-3">Телефон</div>
                <div className="phone-input-login">
                    <PhoneInputComponent
                        placeholder="+7 (____)"
                        value={change_phone.data.phone_number.value}
                        onChange={(value) => { set_input_value({ label: "phone_number", data: validation({ value, type: "phone_number" }) }); }}
                    />
                    {!change_phone.data.phone_number.valid && change_phone.submitted ?
                        <span className={styles.phone_valid}>phone error</span> : null}
                </div>
                <div className="d-flex justify-content-center">
                    <MainButton onClick={() => edit_phone_saga()} title={change_phone.loading ? <ClipLoader color="#464646" size={15} /> : "Сохранить"} />
                </div>
            </div> : <div>
                <div className={styles.title}>Введите код </div>
                <div className={styles.description}>На ваш телефон было отправлено сообщение с кодом. Введите код ниже.</div>
                <NumberFormatInput
                    onKeyDown={() => console.log("lllll")}
                    type="code"
                    placeholder=""
                    value={change_phone.data.confirm_code.value}
                    valid={change_phone.data.confirm_code.valid}
                    submitted={change_phone.code_submitted}
                    onChange={(value) => {
                        set_input_value({ label: "confirm_code", data: validation({ value, type: "code" }) });
                    }
                    }
                    error_message="error code"
                />
                <div className="d-flex justify-content-center">
                    <MainButton onClick={() => {
                        if (!change_phone.loading) {
                            check_phone_saga();
                        }
                    }} title={change_phone.loading ? <ClipLoader color="#464646" size={15} /> : "Сохранить"} />
                </div>
            </div>}

        </div>
    );
    return (
        <ModalComp body={body} open={props.open} setValue={() => props.setValue()} />
    );
}
export default ChangeEmail;